import { NO_ESCAPE_OPTIONS } from "@src/raya-lucaria/i18n/interpolation";
import { Column, Row, Table } from "@tanstack/react-table";
import { TFunction } from "i18next";

export function getColumnLabel<T>(column: Column<T, unknown>): string {
  const { header, meta } = column.columnDef;
  if (typeof header === "string" && header !== "") return header;
  const metaLabel = (meta as { label?: string } | undefined)?.label;
  return metaLabel ?? column.id;
}

export function resolveRowLabel(
  t: TFunction<"translation", undefined>,
  table: Table<any>,
  row: Row<any>,
): string {
  const label = table.options.meta?.getRowLabel?.(row);
  if (label) return label;
  return t("rowLabelFallback", { number: row.index + 1, ...NO_ESCAPE_OPTIONS });
}

export function getRowActionName(
  t: TFunction<"translation", undefined>,
  rowLabel: string,
  action: string,
): string {
  return t("rowActionName", { action, row: rowLabel, ...NO_ESCAPE_OPTIONS });
}

export function getRowMenuName(
  t: TFunction<"translation", undefined>,
  rowLabel: string,
): string {
  return t("rowMenuName", { row: rowLabel, ...NO_ESCAPE_OPTIONS });
}
